import { ICallSessionOutcomeV2 } from 'buddy-api/types/callstatus'
import ApiMixin from '../ApiMixin'
import { TGetInteractionHistory } from 'buddy-api/types/GetInteractionHistroyAPI'

export default class InteractionHistoryAPI extends ApiMixin<
    TGetInteractionHistory,
    ICallSessionOutcomeV2
> {}
